import { useFeatureFlags } from 'hooks/featureFlags'
import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'

export const ServiceWorkerKillSwitch = observer(
  function ServiceWorkerKillSwitch() {
    const ff = useFeatureFlags()
    useEffect(() => {
      if (!ff.serviceWorkerKillSwitch) return

      if (!('serviceWorker' in navigator)) return
      navigator.serviceWorker.getRegistrations().then((registrations) => {
        for (const reg of registrations) {
          reg.unregister()
        }
      })
    }, [ff.serviceWorkerKillSwitch])

    return null
  }
)
